export default __webpack_public_path__ + "static/media/USAA.2863b205.svg";